(() => {
  if (window.__olcPremiumInitialized) return;
  window.__olcPremiumInitialized = true;
  function placeExtras(root = document) {
    root.querySelectorAll('[data-olc-card-extras]').forEach(marker => {
      if (marker.dataset.processed) return;
      let sibling = marker.previousElementSibling;
      let card = sibling && (sibling.matches('.card-wrapper') ? sibling : sibling.querySelector('.card-wrapper'));
      if (!card) card = marker.parentElement?.querySelector('.card-wrapper');
      if (!card) return;
      const media = card.querySelector('.card__media') || card.querySelector('.card__inner');
      const info = card.querySelector('.card__information') || card.querySelector('.card__content');
      const action = marker.querySelector('.olc-explore');
      const dispatch = marker.querySelector('.olc-dispatch');
      if (media && action) {
        media.classList.add('olc-media-ready');
        media.appendChild(action);
      }
      if (info && dispatch) info.appendChild(dispatch);
      marker.dataset.processed = 'true';
    });
  }
  function ready() {
    placeExtras();
    if (document.querySelector('.olc-toolbar-section')) document.body.classList.add('olc-using-toolbar');
    document.querySelectorAll('[data-olc-dialog]').forEach(dialog => {
      const root = dialog.closest('.olc-toolbar-section');
      const open = root?.querySelector('[data-olc-open]');
      const close = dialog.querySelector('[data-olc-close]');
      open?.addEventListener('click', () => dialog.showModal());
      close?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    });
    document.querySelectorAll('[data-olc-sort]').forEach(sel => sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.assign(url.toString());
    }));
    document.querySelectorAll('[data-olc-carousel]').forEach(track => {
      const container = track.closest('.olc-complete__inner');
      container?.querySelectorAll('[data-olc-scroll]').forEach(btn => btn.addEventListener('click', () => track.scrollBy({left: track.clientWidth * (btn.dataset.olcScroll === 'next' ? 0.75 : -0.75),behavior:'smooth'})));
    });
    const observer = new MutationObserver(records => {
      if(records.some(r => r.addedNodes.length)) placeExtras();
    });
    const grid = document.querySelector('#product-grid') || document.querySelector('.product-grid');
    if (grid) observer.observe(grid.parentElement || grid, {childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
